export default __webpack_public_path__ + "static/media/gold.a71739ba.svg";